module.exports = __webpack_public_path__ + "media/images/icons/outlined/sliders-b70b9998debe1791b0e0fe58239cfcdf.svg";